import React from "react";
import "./styles/HomePage.css";

const HomePage: React.FC = () => {
    const scrollToNextSection = (currentSectionId: string) => {
        const currentSection = document.querySelector(`#${currentSectionId}`);
        if (currentSection) {
            currentSection.scrollIntoView({ behavior: "smooth" });
        }
    };
    return (
        <div>
            {/* Parallax Hero Banner */}
            <section className="parallax-banner primary-purpose">
                <div className="content-overlay">
                    <h1 className="section-title">Our Primary Purpose</h1>
                    <p className="section-subtitle">
                        To carry the message to the alcoholic who still suffers.
                    </p>
                    <button
                        className="down-caret"
                        style={{ color: "white" }}
                        onClick={() => scrollToNextSection("section-1")}
                    >
                        &#x2193;
                    </button>
                </div>
            </section>
            {/* AA Preamble Section */}
            <section
                id="section-1"
                className="content-section"
                style={{ backgroundColor: "#fff" }}
            >
                <h2 className="content-title">
                    Welcome to the 5th Tradition Group website.
                </h2>
                <p className="content-text">
                    Here you will find information about our group, meetings,
                    access to past speaker recordings and a way to contact an AA
                    member.
                </p>
                <button
                    className="down-caret"
                    style={{ color: "black", opacity: "0.8" }}
                    onClick={() => scrollToNextSection("section-2")}
                >
                    &#x2193;
                </button>
            </section>
            <div>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1000 100"
                    preserveAspectRatio="none"
                >
                    <path
                        className="shape-fill"
                        d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7
	c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4
	c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"
                    ></path>
                </svg>
            </div>
            {/* Meetings Section */}
            <section id="section-2" className="content-section speakers">
                <h2 className="content-title">Meetings</h2>
                <div className="grid-container">
                    <div className="grid-item">
                        <div className="speaker-card">
                            <img
                                src="/assets/aa-symbol-icon.png"
                                alt="Speaker 1"
                                style={{ borderRadius: "15%" }}
                            />
                            <h3>Tuesday</h3>
                            <p>Beginners Meeting: 7:30pm</p>
                            <a
                                className="link-style"
                                href="https://maps.app.goo.gl/KUhVadayKruLz5So6"
                            >
                                NABA Club
                            </a>
                        </div>
                    </div>
                    <div className="grid-item">
                        <div className="speaker-card">
                            <img
                                src="/assets/aa_bigbook.jpg.webp"
                                style={{ borderRadius: "35%" }}
                                alt="Speaker 2"
                            />
                            <h3>Thursday</h3>
                            <p>Closed Big Book Study: 7pm</p>
                            <a
                                className="link-style"
                                href="https://goo.gl/maps/Su9BCWGtoLGUiTHWA"
                            >
                                Embry Hills UMC
                            </a>
                        </div>
                    </div>
                    <div className="grid-item">
                        <div className="speaker-card">
                            <img src="/assets/samba.jpeg" alt="Speaker 3" />
                            <h3>Friday</h3>
                            <p>SAMBA Open Discussion: 7pm</p>
                            <a
                                className="link-style"
                                href="https://www.google.com/maps/place/Samba+Recovery:+Drug+%26+Alcohol+Rehab+In+Georgia+%7C+Addiction+Treatment+Center+In+Georgia/data=!4m2!3m1!1s0x0:0x58eb237e7085019a?sa=X&ved=1t:2428&ictx=111"
                            >
                                SAMBA Peachtree Corners
                            </a>
                        </div>
                    </div>
                    <div className="grid-item">
                        <div className="speaker-card">
                            <img src="/assets/recoveryV.jpg" alt="Speaker 4" />
                            <h3>Saturday</h3>
                            <p>Open Speaker Meeting: 7pm</p>
                            <a
                                className="link-style"
                                href="https://goo.gl/maps/Su9BCWGtoLGUiTHWA"
                            >
                                Embry Hills UMC
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HomePage;
